module.exports = __webpack_public_path__ + "img/文本进行情感分析.09b9d08e.png";